import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Report as action } from '../../redux/actions';

/**
 * Deletes the desired report.
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const remove = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
  };

  fetch(endpoint('/delete-report'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.remove(model.Report));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default remove;
